import { DataTableCol } from "../../../components/tables/types";

export const FilterAccessDataGridCols: DataTableCol[] = [
    {
        title: 'btechCourse',
        control: 'btechCourse',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Course',
        control: 'course',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Actions',
        control: 'both',
        sortable: false,
        isEdit: true,
        isDelete: true,
        canShowColumn: true
    },
];